function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.0719 15.5738C34.9756 16.1776 36.0382 16.5 37.1251 16.5C38.5823 16.4988 39.9795 15.9194 41.0099 14.889C42.0403 13.8586 42.6197 12.4615 42.6208 11.0043C42.6208 9.9173 42.2985 8.85477 41.6946 7.951C41.0907 7.04724 40.2324 6.34284 39.2282 5.92688C38.224 5.51093 37.119 5.40209 36.0529 5.61415C34.9869 5.8262 34.0076 6.34961 33.2391 7.1182C32.4705 7.88679 31.947 8.86603 31.735 9.93209C31.5229 10.9982 31.6318 12.1032 32.0477 13.1074C32.4637 14.1116 33.1681 14.9699 34.0719 15.5738Z",
  fill: "#FF5670"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M24.4444 20L24.4444 44.4444H0L24.4444 20Z",
  fill: "#FF5670"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5625 6.875C6.28615 6.875 5.06207 7.38203 4.15955 8.28455C3.25703 9.18707 2.75 10.4111 2.75 11.6875V32.3125C2.75 33.5889 3.25703 34.8129 4.15955 35.7155C5.06207 36.618 6.28615 37.125 7.5625 37.125H36.3284C37.6047 37.125 38.8288 36.618 39.7313 35.7155C40.6338 34.8129 41.1409 33.5889 41.1409 32.3125V20.5391C41.1409 19.7797 40.5253 19.1641 39.7659 19.1641C39.0065 19.1641 38.3909 19.7797 38.3909 20.5391V32.3125C38.3909 32.8595 38.1736 33.3841 37.7868 33.7709C37.4 34.1577 36.8754 34.375 36.3284 34.375H7.5625C7.01549 34.375 6.49089 34.1577 6.10409 33.7709C5.7173 33.3841 5.5 32.8595 5.5 32.3125V11.6875C5.5 11.1405 5.7173 10.6159 6.10409 10.2291C6.49089 9.8423 7.01549 9.625 7.5625 9.625H27.5C28.2594 9.625 28.875 9.00939 28.875 8.25C28.875 7.49061 28.2594 6.875 27.5 6.875H7.5625ZM10.4692 12.6646C9.8698 12.1984 9.00593 12.3063 8.5397 12.9058C8.07348 13.5052 8.18147 14.3691 8.78089 14.8353L21.1559 24.4603C21.6466 24.8419 22.3323 24.8469 22.8284 24.4724L30.305 18.8289C30.9111 18.3714 31.0316 17.5091 30.5741 16.903C30.1166 16.2969 29.2543 16.1765 28.6482 16.634L22.0126 21.6427L10.4692 12.6646Z",
  fill: "#0E185B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "white"
})));

var SvgMailUnreadOutline = function SvgMailUnreadOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailUnreadOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail-unread-outline.e2cd6260.svg";
export { ForwardRef as ReactComponent };